import {LinePlotTemplateSettings} from '../../../graphql/workspaceTemplates';
import {DEFAULT_SMOOTHING_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {getSmoothingTypeDisplayName} from '../../WorkspaceDrawer/Settings/runLinePlots/LinePlotSmoothing';
import {LinePlotDisplayFnArgs} from '../types';

export const getSmoothingTypeDisplayRow = ({
  isBackendSmoothingEnabled,
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateSmoothingType = currTemplateLinePlotSettings?.smoothingType;

  const newTemplateSmoothingType = currWorkspaceLinePlotSettings?.smoothingType;
  const newSmoothingTypeValue =
    newTemplateSmoothingType ?? DEFAULT_SMOOTHING_SETTINGS.smoothingType;

  return {
    label: 'Smoothing type',
    field: 'smoothingType' as keyof LinePlotTemplateSettings,
    currValue: currTemplateSmoothingType,
    currDisplayValue:
      currTemplateSmoothingType == null
        ? undefined
        : getSmoothingTypeDisplayName(
            currTemplateSmoothingType,
            isBackendSmoothingEnabled
          ),
    newValue: newSmoothingTypeValue,
    newDisplayValue: getSmoothingTypeDisplayName(
      newSmoothingTypeValue,
      isBackendSmoothingEnabled
    ),
  };
};

export const getSmoothingWeightDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateSmoothingWeight =
    currTemplateLinePlotSettings?.smoothingWeight;

  const newTemplateSmoothingWeight =
    currWorkspaceLinePlotSettings?.smoothingWeight;
  const newSmoothingWeightValue =
    newTemplateSmoothingWeight ?? DEFAULT_SMOOTHING_SETTINGS.smoothingWeight;

  return {
    label: 'Smoothing weight',
    field: 'smoothingWeight' as keyof LinePlotTemplateSettings,
    // preserve the value that's used in db
    currValue: currTemplateSmoothingWeight,
    currDisplayValue:
      currTemplateSmoothingWeight == null
        ? undefined
        : currTemplateSmoothingWeight.toString(),
    newValue: newSmoothingWeightValue,
    newDisplayValue: newSmoothingWeightValue.toString(),
  };
};
